<template>
  <div>
    <!-- <wizard-btn :currentStep="mode"/> -->
    <div class="d-flex">
      <button
        class="btn btn-block shadow d-flex m-2"
        :class="{
          'btn-outline-primary': mode !== 1,
          'btn-primary': mode === 1,
        }"
        type="button"
        @click="changeMode(1)"
      >
        <div class="title-step">
          <icon-check v-if="stepStatus[1]" /><icon-warn v-else />
          <div>ข้อมูลหอพัก</div>
        </div>
      </button>
      <button
        class="btn btn-block shadow d-flex m-2"
        :class="{
          'btn-outline-primary': mode !== 2,
          'btn-primary': mode === 2,
        }"
        type="button"
        @click="changeMode(2)"
      >
        <div class="title-step">
          <icon-check v-if="stepStatus[2]" /><icon-warn v-else />
          <div>ที่อยู่หอพัก</div>
        </div>
      </button>
      <button
        class="btn btn-block shadow d-flex m-2"
        :class="{
          'btn-outline-primary': mode !== 3,
          'btn-primary': mode === 3,
        }"
        type="button"
        @click="changeMode(3)"
      >
        <div class="title-step">
          <icon-check v-if="stepStatus[3]" /><icon-warn v-else />
          <div>ข้อมูลห้องพัก</div>
        </div>
      </button>
      <button
        class="btn btn-block shadow d-flex m-2"
        :class="{
          'btn-outline-primary': mode !== 4,
          'btn-primary': mode === 4,
        }"
        type="button"
        @click="changeMode(4)"
      >
        <div class="title-step">
          <icon-check v-if="stepStatus[4]" /><icon-warn v-else />
          <div>ภาพประกอบ</div>
        </div>
      </button>
      <button
        class="btn btn-block shadow d-flex m-2"
        :class="{
          'btn-outline-primary': mode !== 5,
          'btn-primary': mode === 5,
        }"
        type="button"
        @click="changeMode(5)"
      >
        <div class="title-step">
          <icon-check v-if="stepStatus[5]" /><icon-warn v-else />
          <div>กฏระเบียบหอพัก</div>
        </div>
      </button>
      <button
        v-if="value.objectId && stepStatus[6]"
        class="btn btn-block btn-outline-success shadow d-flex m-2"
        type="button"
        @click="changeMode(6)"
      >
        <div class="title-step">
          <img
            :src="require('../../assets/brand.png')"
            alt=""
            style="width: 110px"
          />
          <div>ดูประกาศหอพักคุณ</div>
        </div>
      </button>
    </div>
    <div class="card mt-3 shadow">
      <div class="card-body">
        <div class="container" v-show="mode === 1">
          <div class="form-group">
            <label>ชื่อหอพัก (ภาษาไทย) <span class="required">*</span></label>
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': missingForm['name'] }"
              v-model="value.name"
              :readonly="disabled"
              placeholder="ชื่อหอพัก"
            />
          </div>
          <div class="form-group">
            <label>ชื่อหอพัก (ภาษาอังกฤษ)</label>
            <input
              type="text"
              class="form-control"
              v-model="value.name_en"
              :readonly="disabled"
              placeholder="ชื่อหอพัก"
            />
          </div>
          <div class="form-group row">
            <div class="col-md-6 col-sm-12">
              <label>ชื่อผู้ดูแล <span class="required">*</span></label>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': missingForm['ownerName'] }"
                v-model="value.ownerName"
                :readonly="disabled"
                placeholder="ชื่อผู้ดูแล"
              />
            </div>
            <div class="col-md-6 col-sm-12">
              <label>ประเภทหอพัก <span class="required">*</span></label>
              <select
                class="form-control"
                :class="{ 'is-invalid': missingForm['sexType'] }"
                v-model="value.sexType"
                :disabled="disabled"
              >
                <option value="shared">
                  <i class="fas fa-male"></i
                  ><i class="fas fa-female"></i> หอพักรวม (ชาย/หญิง)
                </option>
                <option value="male">
                  <i class="fas fa-male"></i> หอพักชาย
                </option>
                <option value="female">
                  <i class="fas fa-female"></i> หอพักหญิง
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6 col-sm-12">
              <label>เบอร์โทรศัพท์ <span class="required">*</span></label>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': missingForm['tel'] }"
                v-model="value.tel"
                :readonly="disabled"
                placeholder="เบอร์โทรศัพท์"
              />
            </div>
            <div class="col-md-6 col-sm-12">
              <label>อีเมลติดต่อหอพัก</label>
              <input
                type="email"
                class="form-control"
                v-model="value.email"
                :readonly="disabled"
              />
            </div>
          </div>
          <label
            >ระยะเวลาสัญญาเช่าขั้นต่ำ (เดือน)
            <span class="required">*</span></label
          >
          <div class="form-group row">
            <div class="col-md-4 col-sm-6">
              <input
                type="number"
                class="form-control"
                v-model="value.contract"
                :disabled="disabled"
              />
            </div>
            <label class="col-md-4 col-sm-6 col-form-label">เดือน</label>
          </div>
          <div class="form-group">
            <label><i class="fas fa-tint"></i> ค่าน้ำ <span class="required">*</span></label>
            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': missingForm['waterCost'] }"
                v-model="value.waterCost"
                :readonly="disabled"
                placeholder="เช่น 25 บาท/หน่วย"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="value.waterCost = getWaterCostRange(rooms)"
                >
                  <i class="fas fa-sync-alt"></i>
                </button>
              </div>
            </div>
            <!-- <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="value.hiddenWaterCost" :disabled="disabled">
              <label class="form-check-label">ไม่แสดงบนหน้าเว็บ</label>
            </div> -->
          </div>
          <div class="form-group">
            <label><i class="fas fa-bolt"></i> ค่าไฟ <span class="required">*</span></label>
            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': missingForm['elecCost'] }"
                v-model="value.elecCost"
                :readonly="disabled"
                placeholder="เช่น 7 บาท/หน่วย"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="value.elecCost = getElecCostRange(rooms)"
                >
                  <i class="fas fa-sync-alt"></i>
                </button>
              </div>
            </div>
            <!-- <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="value.hiddenElecCost" :disabled="disabled">
              <label class="form-check-label">ไม่แสดงบนหน้าเว็บ</label>
            </div> -->
          </div>
          <div class="form-group">
            <label>จุดเด่นของที่พัก</label>
            <textarea
              v-model="value.highlightDetail"
              class="form-control"
              rows="4"
              placeholder="เช่น อพาร์ทเม้นท์สะอาด ปลอดภัย มีสิ่งอำนวยความสะดวกครบครัน ตอบโจทย์การใช้ชีวิตการเรียน ทำงาน สะดวกสบาย มีทั้งที่จอดรถฟรี เงียบสงบ ปลอดภัยด้วยกล้องวงจรปิด 24 ชม."
            ></textarea>
          </div>
          <div class="form-group">
            <label>สถานที่ใกล้เคียง</label>
            <textarea
              v-model="value.nearbyDetail"
              class="form-control"
              rows="2"
              placeholder="เช่น ใกล้รถไฟฟ้า BTS / มีร้านสะดวกซื้อ / วินมอเตอร์ไซค์หน้าปากซอย"
            ></textarea>
          </div>
          <!-- <div class="form-group" v-for="(service,id) in value.servicesCost" :key="id">
            <label>{{service.name}}</label>
            <input 
              type="text" 
              class="form-control"
              v-model="service.text"
              :readonly="disabled"
              :placeholder="generateServiceCost(service)">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="service.isHidden" :disabled="disabled">
              <label class="form-check-label">ไม่แสดงบนหน้าเว็บ</label>
            </div>
          </div> -->
          <apartment-facility-select
            :facilities="facilities"
            v-model="value.facilities"
            :disabled="disabled"
            :apartmentId="value.apartmentId"
          />
        </div>
        <div class="container" v-show="mode === 2">
          <div class="row mb-2">
            <div class="col-md-4 col-sm-12">
              <div class="form-group">
                <h5>ที่อยู่หอพัก</h5>
                <!-- <small>พิมพ์ชื่อสถานที่เพื่อค้นหาที่อยู่หอพักของท่าน</small>
                <input 
                  type="text" 
                  class="form-control mb-1" 
                  v-model="value.address" 
                  placeholder="ค้นหาชื่อสถานที่, ตำบล, อำเภอ หรือจังหวัด"
                  @focus="isShowAutocomplete=true"
                  @blur="isShowAutocomplete=false"
                  @input="updateAutoComplete(value.address)"
                  @change="panMapToLocation(getAddress());isShowAutocomplete=false;"
                > -->
                <!-- <div class="autocomplete-dropdown" v-if="isShowAutocomplete">
                  <div class="autocomplete-dropdown-item" v-for="(place, index) in autocompleteLocations" :key="index" @mousedown="selectPlace(place)">
                    <i class="fas fa-map-marker-alt"></i> {{place.description}}
                  </div>
                  <div class="text-center text-muted" v-if="!autocompleteLocations">ไม่พบสถานที่</div>
                  <div class="text-center text-muted" v-if="!value.address">กรุณากรอกชื่อสถานที่</div>
                </div> -->
              </div>
              <div class="form-group">
                <label>บ้านเลขที่ ถนน <span class="required">*</span></label>
                <input
                  type="text"
                  v-model="value.address"
                  placeholder="กรุณากรอกบ้านเลขที่ ถนน"
                  class="form-control"
                  :class="{ 'is-invalid': missingForm['address'] }"
                />
              </div>
              <div class="form-group">
                <label>จังหวัด <span class="required">*</span></label>
                <select
                  v-model="value.provinceCode"
                  id="province-select"
                  @change="provinceChanged"
                >
                  <option data-placeholder="true"></option>
                  <option
                    v-for="province in provinces"
                    :key="province.PROVINCE_ID"
                    :value="province.PROVINCE_CODE"
                  >
                    {{ province.PROVINCE_NAME }}
                  </option>
                </select>
                <div class="text-red" v-if="missingForm['provinceCode']">
                  <i class="fas fa-exclamation-circle"></i> กรุณาเลือกจังหวัด
                </div>
              </div>
              <div class="form-group">
                <label>อำเภอ/เขต <span class="required">*</span></label>
                <select
                  v-model="value.districtCode"
                  id="district-select"
                  @change="districtChanged"
                >
                  <option data-placeholder="true"></option>
                  <option
                    v-for="district in filteredDistricts"
                    :key="district.DISTRICT_ID"
                    :value="district.DISTRICT_CODE"
                  >
                    {{ district.DISTRICT_NAME }}
                  </option>
                </select>
                <div class="text-red" v-if="missingForm['districtCode']">
                  <i class="fas fa-exclamation-circle"></i> กรุณาเลือกจังหวัด
                </div>
              </div>
              <div class="form-group">
                <label>ตำบล/แขวง</label>
                <select
                  v-model="value.subDistrictCode"
                  id="sub-district-select"
                  @change="subDistrictChanged"
                >
                  <option data-placeholder="true"></option>
                  <option
                    v-for="subDistrict in filteredSubDistricts"
                    :key="subDistrict.SUB_DISTRICT_ID"
                    :value="subDistrict.SUB_DISTRICT_CODE"
                  >
                    {{ subDistrict.SUB_DISTRICT_NAME }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-8 col-sm-12">
              <h5>ระบุตำแหน่งหอพักบนแผนที่ <span class="required">*</span></h5>
              <div class="text-muted">
                ปรับตำแหน่งได้โดยการกดค้างที่
                <img
                  src="https://maps.gstatic.com/mapfiles/markers2/marker.png"
                  alt="map marker"
                />
              </div>
              <button
                class="btn btn-outline-primary btn-block mt-2"
                type="button"
                @click.prevent="getUserPosition"
              >
                <i class="fas fa-street-view"></i> ดึงตำแหน่งปัจจุบัน
              </button>
              <div class="text-red" v-if="missingForm['position']">
                <i class="fas fa-exclamation-circle"></i> กรุณาระบุตำแหน่งหอพักของคุณ
              </div>
              <GmapMap
                id="map"
                :center.sync="center"
                :zoom.sync="zoom"
                class="mt-2"
                ref="apartmentMap"
                :options="mapOption"
                @click="setCenter"
              >
                <GmapMarker
                  v-if="marker"
                  :position="marker.position"
                  :draggable="true"
                  @dragend="onMarkerDragEnd"
                />
              </GmapMap>
            </div>
          </div>
        </div>
        <div class="container" v-show="mode === 3">
          <room-type-form
            v-model="value.roomTypes"
            :deleteRoomTypes="value.deleteRoomTypes"
            :onDeleteRoomType="onDeleteRoomType"
            :rooms="rooms"
            :apartmentId="value.apartmentId"
            :room-features="roomFeatures"
            :missingForm="missingForm"
          />
        </div>
        <div class="container" v-show="mode === 4">
          <div class="card mb-2">
            <div class="card-header">
              <h5>รูปภาพหอพัก</h5>
              <small><span class="text-danger">*</span> จำเป็นต้องเพิ่มอย่างน้อย 1 ภาพ</small>
              <div class="text-red" v-if="missingForm['mainImage']">
                <i class="fas fa-exclamation-circle"></i> กรุณาเพิ่มรูปภาพอย่างน้อย 1 ภาพ
              </div>
            </div>
            <div class="card-body">
              <upload-image-style prefix="main-images" v-model="value.images" />
            </div>
          </div>
          <div
            class="card mb-2"
            v-for="(roomType, index) in value.roomTypes"
            :key="index"
          >
            <div class="card-header">
              <h5>รูปภาพภายในห้องพักประเภท {{ roomType.name }}</h5>
              <small><span class="text-danger">*</span> จำเป็นต้องเพิ่มอย่างน้อย 1 ภาพ</small>
              <div class="text-red" v-if="missingForm['roomTypeImage_'+index]">
                <i class="fas fa-exclamation-circle"></i> กรุณาเพิ่มรูปภาพอย่างน้อย 1 ภาพ
              </div>
            </div>
            <div class="card-body">
              <upload-image-style
                :prefix="`roomtype-images-${index}`"
                v-model="roomType.images"
              />
            </div>
          </div>
        </div>
        <div class="container" v-show="mode === 5">
          <div class="form-group mt-3">
            <label>กฏระเบียบของหอพัก <span class="required">*</span></label>
            <div
              class="input-group mb-3"
              v-for="(rule, index) in value.apartmentRules"
              :key="index"
            >
              <input
                type="text"
                placeholder="คลิกที่นี่ เพื่อเพิ่มรายละเอียด.. เช่น ห้ามดื่มสุรา, ห้ามส่งเสียงดังหลัง 22.00 น."
                class="form-control"
                :class="{ 'is-invalid': missingForm['apartmentRules'] }"
                v-model="value.apartmentRules[index]"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-danger"
                  type="button"
                  @click.prevent="removeApartmentRule(index)"
                >
                  <i class="fas fa-trash-alt" />
                </button>
              </div>
            </div>
            <button
              class="btn btn-primary btn-block mb-2"
              @click.prevent="addApartmentRule"
            >
              เพิ่ม
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "underscore";
import provinces from "@/assets/dataset/province.json";
import districts from "@/assets/dataset/district.json";
import subDistricts from "@/assets/dataset/subDistrict.json";
export default {
  props: [
    "value",
    "onSave",
    "disabled",
    "rooms",
    "facilities",
    "roomFeatures",
    "mode",
    "onModeChange",
    "stepStatus",
    "missingForm"
  ],
  data() {
    return {
      rentiniUrl: process.env.VUE_APP_RENTINI_BASE_URL,
      map: null,
      marker: null,
      landmarks: [],
      isAddingLandmark: false,
      isAddingArea: false,
      zoom: 16,
      isShowAutocomplete: false,
      autocompleteLocations: [],
      mapOption: {
        gestureHandling: "greedy",
      },
      center: {
        lat: 13.7244416,
        lng: 100.3529157,
      },
      provinces,
      districts,
      subDistricts,
      filteredDistricts: [],
      filteredSubDistricts: [],
    };
  },
  methods: {
    selectPlace(place) {
      this.value.address = place.structured_formatting.main_text + " ";
      let queryPlace = this.getAddress();
      this.panMapToLocation(queryPlace);
    },
    async onFileChanged(e) {
      const files = e.target.files;
      this.value.base64Images = [];
      for (let file of files) {
        let base64 = await this.readURL(file);
        this.value.base64Images.push({
          name: file.name,
          data: base64,
        });
      }
      this.$emit("input", this.value);
    },
    readURL(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          resolve(e.target.result);
        };
        reader.readAsDataURL(file);
      });
    },
    onDeleteRoomType(id) {
      if (!this.value.deleteRoomTypes) this.value.deleteRoomTypes = [];
      this.value.deleteRoomTypes.push(id);
      this.$emit("input", this.value);
    },
    setPrimaryImage(index) {
      let image = this.value.images.splice(index, 1)[0];
      this.value.images.unshift(image);
      this.$emit("input", this.value);
    },
    addApartmentRule() {
      if (!this.value.apartmentRules) this.value.apartmentRules = [];
      this.value.apartmentRules.push("");
      this.$emit("input", this.value);
      this.$mount();
    },
    removeApartmentRule(index) {
      this.value.apartmentRules.splice(index, 1);
      this.$emit("input", this.value);
      this.$mount();
    },
    panMapToLocation(query) {
      // eslint-disable-next-line
      let placeSearch = new google.maps.places.PlacesService(this.map);
      placeSearch.findPlaceFromQuery(
        {
          fields: ["name", "geometry.location", "formatted_address"],
          query,
        },
        (res, status) => {
          if (status !== "OK") {
            // alert(status)
          } else {
            if (res.length > 0) {
              this.map.panTo(res[0].geometry.location);
              this.marker.position = res[0].geometry.location;
              this.value.position = res[0].geometry.location;
              this.center = res[0].geometry.location;
            }
          }
        }
      );
      this.isShowAutocomplete = false;
    },
    changeMode(index) {
      if (index === 6) {
        window.open(`${this.rentiniUrl}/p/${this.value.objectId}`, "_blank");
        return;
      }
      if (this.onModeChange && typeof this.onModeChange === "function") {
        this.onModeChange(index);
      }
    },
    setCenter(event) {
      this.center = event.latLng;
      this.value.position = event.latLng;
      this.marker.position = event.latLng;
    },
    onMarkerDragEnd(event) {
      this.value.position = event.latLng;
      this.marker.position = event.latLng;
    },
    updateAutoComplete(input) {
      if (input) {
        // eslint-disable-next-line
        let autoComplete = new google.maps.places.AutocompleteService();
        autoComplete.getPlacePredictions(
          {
            input,
            componentRestrictions: { country: ["th"] },
          },
          (res) => {
            this.autocompleteLocations = res;
          }
        );
      } else {
        this.autocompleteLocations = [];
      }
    },
    getElecCostRange(rooms) {
      let room = rooms[0];
      if (room.get("standardRate")) {
        let standardRate = room.get("standardRate");

        // เหมาจ่ายรายเดือน
        if (standardRate.get("elecCost_month")) {
          return `${standardRate.get("elecCost_month") || 0} บาท/เดือน`;
        } else if (standardRate.get("elecCost_unit")) {
          let elecCostString = "";

          // คิดตามจริง
          if (standardRate.get("elecCost_unit"))
            elecCostString += `${standardRate.get("elecCost_unit")} บาท/หน่วย `;

          // คิดตามจริง ขั้นต่ำเป็นยูนิต
          if (
            standardRate.get("elecUnit_al") &&
            standardRate.get("elecUnit_al_cost")
          ) {
            elecCostString += `ขั้นต่ำ ${standardRate.get(
              "elecUnit_al"
            )} หน่วย ${standardRate.get("elecUnit_al_cost")} บาท`;
          }

          // คิดตามจริง ขั้นต่ำเป็นจำนวนเงิน
          if (standardRate.get("elecCost_al")) {
            elecCostString += `ขั้นต่ำ ${standardRate.get("elecCost_al")} บาท`;
          }

          return elecCostString;
        }
      }

      return null;
    },
    getWaterCostRange(rooms) {
      let room = rooms[0];
      if (room.get("standardRate")) {
        let standardRate = room.get("standardRate");

        // เหมาจ่ายรายเดือน
        if (standardRate.get("waterCost_month")) {
          return `${standardRate.get("waterCost_month") || 0} บาท/เดือน`;
        } else if (standardRate.get("waterCost_unit")) {
          let waterCostString = "";

          // คิดตามจริง
          if (standardRate.get("waterCost_unit"))
            waterCostString += `${standardRate.get(
              "waterCost_unit"
            )} บาท/หน่วย `;

          // คิดตามจริง ขั้นต่ำเป็นยูนิต
          if (
            standardRate.get("waterUnit_al") &&
            standardRate.get("waterUnit_al_cost")
          ) {
            waterCostString += `ขั้นต่ำ ${standardRate.get(
              "waterUnit_al"
            )} หน่วย ${standardRate.get("waterUnit_al_cost")} บาท`;
          }

          // คิดตามจริง ขั้นต่ำเป็นจำนวนเงิน
          if (standardRate.get("waterCost_al")) {
            waterCostString += `ขั้นต่ำ ${standardRate.get(
              "waterCost_al"
            )} บาท`;
          }

          return waterCostString;
        }
      }

      return null;
    },
    generateServiceCost(service) {
      let string = "";
      if (service.types[0]) {
        if (service.types[0].min === service.types[0].max)
          string += `${service.types[0].min} บาท/เดือน `;
        else
          string += `${service.types[0].min} - ${service.types[0].max} บาท/เดือน `;
      }
      if (service.types[1]) {
        if (service.types[1].min === service.types[1].max)
          string += `${service.types[1].min} บาท/หน่วยค่าน้ำ `;
        else
          string += `${service.types[1].min} - ${service.types[1].max} บาท/หน่วยค่าน้ำ `;
      }
      if (service.types[2]) {
        if (service.types[2].min === service.types[2].max)
          string += `${service.types[2].min} บาท/หน่วยค่าไฟ `;
        else
          string += `${service.types[2].min} - ${service.types[2].max} บาท/หน่วยค่าไฟ `;
      }
      return string;
    },
    provinceChanged() {
      this.filteredDistricts = this.districtByProvinceCode(
        this.value.provinceCode
      );

      this.value.districtCode = this.filteredDistricts[0].DISTRICT_CODE;

      this.filteredSubDistricts = this.subDistrictByDistrictCode(
        this.filteredDistricts[0].DISTRICT_CODE
      );
      this.value.subDistrictCode = this.filteredSubDistricts[0].SUB_DISTRICT_CODE;

      let queryPlace = this.getAddress();
      this.panMapToLocation(queryPlace);
    },
    districtChanged() {
      this.filteredSubDistricts = this.subDistrictByDistrictCode(
        this.value.districtCode
      );
      this.value.subDistrictCode = this.filteredSubDistricts[0].SUB_DISTRICT_CODE;

      let queryPlace = this.getAddress();
      this.panMapToLocation(queryPlace);
    },
    subDistrictChanged() {
      let queryPlace = this.getAddress();
      this.panMapToLocation(queryPlace);
    },
    districtByProvinceCode(code) {
      if (!code) return [];
      let province = this.provinces.find((p) => p.PROVINCE_CODE == code);
      if (province) {
        let districts = this.districts.filter(
          (d) => d.PROVINCE_ID == province.PROVINCE_ID
        );
        return districts;
      }
      return [];
    },
    subDistrictByDistrictCode(code) {
      if (!code) return [];
      let district = this.districts.find((d) => d.DISTRICT_CODE == code);
      if (district) {
        let subDistricts = this.subDistricts.filter(
          (s) => s.DISTRICT_ID == district.DISTRICT_ID
        );
        return subDistricts;
      }
      return [];
    },
    getAddress() {
      let string = "";
      if (this.value.address) {
        string += this.value.address + " ";
      }
      if (this.value.provinceCode) {
        let province = _.findWhere(this.provinces, {
          PROVINCE_CODE: this.value.provinceCode,
        });
        if (province) string += province.PROVINCE_NAME + " ";
      }
      if (this.value.districtCode) {
        let district = _.findWhere(this.filteredDistricts, {
          DISTRICT_CODE: this.value.districtCode,
        });
        if (district) string += district.DISTRICT_NAME + " ";
      }
      if (this.value.subDistrictCode) {
        let subDistrict = _.findWhere(this.filteredSubDistricts, {
          SUB_DISTRICT_CODE: this.value.subDistrictCode,
        });
        if (subDistrict) string += subDistrict.SUB_DISTRICT_NAME + " ";
      }
      return string;
    },
    copyPublishUrl() {
      let tempInput = document.createElement("input");
      tempInput.style = "position: absolute; left: -1000px; top: -1000px";
      tempInput.value = `https://rentini.in.th/${this.value.apartmentCode}`;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);

      this.$toasted.show(`บันทึก link ไปยัง clipboard แล้ว`, {
        theme: "toasted-primary",
        position: "top-center",
        duration: 2000,
      });
    },
    async getUserPosition() {
      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
          (position) => {
            this.value.position = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            this.marker.position = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            this.center = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
          },
          null,
          {
            enableHighAccuracy: false,
            timeout: 5000,
            maximumAge: Infinity,
          }
        );
      }
    },
  },
  async mounted() {
    if (this.$refs.apartmentMap) {
      this.map = await this.$refs.apartmentMap.$mapPromise;
      // $('<div/>').addClass('centerMarker').appendTo(this.map.getDiv())
      //get apartment address
      if (
        this.value.provinceCode &&
        this.value.districtCode &&
        this.value.subDistrictCode
      ) {
        this.filteredDistricts = this.districtByProvinceCode(
          this.value.provinceCode
        );
        this.filteredSubDistricts = this.subDistrictByDistrictCode(
          this.value.districtCode
        );
        if (!this.value.position.lat && !this.value.position.lng) {
          this.panMapToLocation(this.getAddress());
        } else {
          this.center = {
            lat: this.value.position.lat,
            lng: this.value.position.lng,
          };
        }
      }

      //init costs
      if (!this.value.waterCost)
        this.value.waterCost = this.getWaterCostRange(this.rooms);
      if (!this.value.elecCost)
        this.value.elecCost = this.getElecCostRange(this.rooms);

      for (let serviceId in this.value.servicesCost) {
        this.value.servicesCost[serviceId].text = this.generateServiceCost(
          this.value.servicesCost[serviceId]
        );
        this.value.servicesCost[serviceId].isHidden = false;
      }

      new this.$slimSelect({
        select: "#province-select",
      });
      new this.$slimSelect({
        select: "#district-select",
      });
      new this.$slimSelect({
        select: "#sub-district-select",
      });
    }
  },
  async created() {
    if (
      this.value.position &&
      this.value.position.latitude &&
      this.value.position.longitude
    ) {
      this.value.position.lat = this.value.position.latitude;
      this.value.position.lng = this.value.position.longitude;

      this.center = {
        lat: this.value.position.latitude,
        lng: this.value.position.longitude,
      };
    }
    this.marker = {
      position: this.value.position,
    };
  },
  computed: {
    publishUrl() {
      return `https://rentini.in.th/${this.value.apartmentCode}`;
    },
  },
  watch: {
    value: {
      handler() {
        if (this.value.contract) {
          this.value.contract = parseInt(
            String(this.value.contract).substring(0, 2)
          );
        } else {
          this.value.contract = 0;
        }
        this.$emit("input", this.value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/tokens/index";
#map {
  width: 100%;
  height: 400px;
  border-radius: 0.25em;
  margin-bottom: 25px;
}

.autocomplete-dropdown {
  position: absolute;
  margin-top: 5px;
  border-radius: 0.25em;
  padding: 5px;
  z-index: 20000;
  background-color: white;
  width: 100%;
  box-shadow: 2px 2px 10px #cccccc;
}

.autocomplete-dropdown-item {
  border-radius: 0.25em;
  padding: 5px;
}

.autocomplete-dropdown-item:hover {
  color: white;
  cursor: pointer;
  background-color: $color-primary;
}

.title-step {
  vertical-align: middle;
  text-align: center;
  text-overflow: ellipsis;
  flex: 1;
}

.text-red {
  color: red;
}
</style>

